import React, { Component } from 'react';
import { Layout } from 'antd';
import { PAYMENT_PAGE_BG } from '../../constants';
import './index.scss';

const { Content } = Layout;


class SimpleLayout extends Component {
    render() {
        return (
            <div className="simple-layout-wrapper">
                <Layout style={{backgroundImage: `url(${PAYMENT_PAGE_BG})`, backgroundRepeat: "no-repeat", backgroundPosition: "bottom", backgroundAttachment: "fixed"}}>
                    <Content>
                        {React.cloneElement(this.props.children)}
                    </Content>
                </Layout>
            </div>
        )
    }
}

export default SimpleLayout;
